module.exports = __webpack_public_path__ + "static/media/icon-study.f8264c50.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mywk/icon-study.png
// module id = 2077
// module chunks = 4